import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function FinalCTA() {
  return (
    <section
      className="bg-[#0B0B0C] border-t border-[#343437] relative overflow-hidden"
      data-testid="home-final-cta"
      aria-labelledby="home-final-cta-title"
    >
      <div
        className="absolute inset-0 opacity-25 pointer-events-none"
        style={{
          background:
            "radial-gradient(900px 400px at 88% 20%, rgba(216,169,54,0.10), transparent 60%)",
        }}
        aria-hidden
      />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 py-20 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-end">
          <div className="lg:col-span-9">
            <p className="eyebrow">Let's connect</p>
            <motion.h2
              id="home-final-cta-title"
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7 }}
              className="mt-4 font-display leading-[0.98] tracking-[-0.02em] text-[#FAF9F6]"
              style={{ fontSize: "clamp(2.25rem, 4.5vw, 4rem)" }}
            >
              Have a complex problem <br className="hidden md:block" />
              that needs <span className="text-[#D8A936]">making simpler?</span>
            </motion.h2>
            <p className="mt-5 text-[#A9A9A6] leading-relaxed max-w-xl text-[15.5px]">
              Senior roles, transformation programs, consulting engagements or a coffee. I reply within two business days.
            </p>
          </div>
          <div className="lg:col-span-3 flex flex-col gap-3 lg:items-end">
            <Link
              to="/contact"
              data-testid="home-final-cta-primary"
              className="btn-primary"
            >
              Let's talk <ArrowUpRight size={16} />
            </Link>
            <Link
              to="/case-studies"
              data-testid="home-final-cta-secondary"
              className="inline-flex items-center gap-2 text-[#A9A9A6] font-display text-[11.5px] tracking-[0.18em] uppercase border-b border-[#343437] pb-1 hover:text-[#D8A936] hover:border-[#D8A936] transition-colors"
            >
              Or see the work <ArrowUpRight size={12} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
